document.addEventListener('DOMContentLoaded', function() {
  const closeButton = document.querySelector('.announcement-bar .close-announcement');
  
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      const announcementBar = this.closest('.announcement-bar');
      announcementBar.style.display = 'none';
      
      // 设置Cookie记录关闭状态（24小时有效）
      document.cookie = "announcementClosed=true; max-age=86400; path=/";
    });
  }
  
  // 检查Cookie是否已关闭
  if (document.cookie.split(';').some(item => item.trim().startsWith('announcementClosed='))) {
    document.querySelector('.announcement-bar').style.display = 'none';
  }
});